import { render, staticRenderFns } from "./smallButton.vue?vue&type=template&id=0b4be54b&scoped=true"
import script from "./smallButton.vue?vue&type=script&lang=js"
export * from "./smallButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4be54b",
  null
  
)

export default component.exports